import { Check, Loader2, ArrowDownToLine, RotateCcw, AlertCircle } from 'lucide-preact'
import type { DeploymentStatus } from '@/types/landingPage'

/**
 * Badge presentation for a landing-page deployment status. Extracted from LandingPageTab so the
 * search filter can match on the label a user actually SEES ("Rolled Back") rather than the wire
 * value ("RolledBack") — mirroring how assetMeta backs useAssetSearchFilter. ORB-501.
 */
export const DEPLOYMENT_STATUS_STYLES: Record<DeploymentStatus, { label: string; cls: string; icon: typeof Check }> = {
    Live:       { label: 'Live',        cls: 'bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400', icon: Check },
    Pending:    { label: 'Pending',     cls: 'bg-amber-100 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400', icon: Loader2 },
    Superseded: { label: 'Superseded',  cls: 'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300', icon: ArrowDownToLine },
    RolledBack: { label: 'Rolled Back', cls: 'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300', icon: RotateCcw },
    Failed:     { label: 'Failed',      cls: 'bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400', icon: AlertCircle },
}

/**
 * Display order for the status dropdown — lifecycle order rather than alphabetical, so the two
 * statuses anyone actually filters for (Live, Failed) are not buried between the archival ones.
 */
const DEPLOYMENT_STATUS_ORDER: DeploymentStatus[] = ['Live', 'Pending', 'Failed', 'Superseded', 'RolledBack']

export function getDeploymentStatusRank(status: DeploymentStatus): number {
    const rank = DEPLOYMENT_STATUS_ORDER.indexOf(status)
    return rank < 0 ? DEPLOYMENT_STATUS_ORDER.length : rank
}

export function getDeploymentStatusLabel(status: DeploymentStatus): string {
    return DEPLOYMENT_STATUS_STYLES[status]?.label ?? status
}
